import type { SchemaField, SchemaSlotLayout } from '@cli-types/core-engine/schema.js'
import { flattenSlotLayout } from '@core-engine/schema/slot-layout/flatten-slot-layout.js'

export function readSchemaSlotFields(slot: SchemaSlotLayout | undefined): SchemaField[] {
  return flattenSlotLayout(slot)
}
